<template>
    <div class="block block-rounded block-mode-loading-refresh block-bordered">
        <div class="block-content block-content-full block-content-sm bg-body-dark">
            <input type="text" class="form-control form-control-alt" placeholder="Search Accounts..">
        </div>
        <div class="block-content">
            <table class="table table-striped table-hover table-borderless table-vcenter font-size-sm">
                <thead>
                <tr class="border-bottom">
                    <th class="font-w700">Account Name</th>
                    <th class="d-none d-sm-table-cell text-right font-w700">Balance</th>
                    <th class="font-w700">Last Used</th>
                    <th class="font-w700">Expiry</th>
                    <th class="d-none d-sm-table-cell font-w700 text-right">Account Type</th>
                    <th class="font-w700 text-center" style="width: 60px;">...</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(account, index) in accounts.data" :key="index">
                    <td>
                        <span class="font-w600">{{account.name}}</span>
                    </td>
                    <td class="d-none d-sm-table-cell text-right">
                        <span class="font-size-sm font-w700">{{account.availableBalance}}</span>
                    </td>
                    <td>
                        <span class="font-w700">{{account.lastTransactionAt}}</span>
                    </td>
                    <td>
                        <span class="font-w700">{{account.expireAt}}</span>
                    </td>
                    <td class="d-none d-sm-table-cell text-right text-success">
                        <strong v-if="account.isDefault === 1"
                                class="badge badge-circle badge-success font-w700 text-uppercase badge-primary">
                            Default
                        </strong>
                        <strong
                            class="badge badge-circle badge-success font-w700 text-uppercase"
                            :class="{'badge-warning': account.account_type == 'credit'}"
                        >{{account.account_type}}</strong>
                    </td>
                    <td class="text-center">
                        <div class="dropdown">
                            <button type="button" class="btn-block-option" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                <i class="si si-menu"/>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                                <a @click.prevent="viewAccount(account.id)" class="dropdown-item" href="#">
                                    <i class="far fa-fw fa-folder-open mr-1"/> View Account
                                </a>
                                <a @click.prevent="transferCredits(account.id)" class="dropdown-item" href="#">
                                    <i class="fa fa-fw fa-exchange-alt mr-1"/> Transfer Credits
                                </a>
                                <a v-if="user && user.id === account.user_id && account.isDefault === 0"
                                   @click.prevent="makeDefault(account.id)"
                                   class="dropdown-item" href="#">
                                    <i class="fa fa-fw fa-check-double mr-1"/> Make as Default
                                </a>
                                <a v-if="user && user.id === account.user_id"
                                   @click.prevent="openShareDialog(account.id)"
                                   class="dropdown-item" href="#">
                                    <i class="fa fa-fw fa-share-alt mr-1"/> Share Account
                                </a>
                                <div role="separator" class="dropdown-divider"></div>
                                <a v-if="user && user.id === account.user_id" class="dropdown-item text-danger"
                                   @click="deleteAccount(account.id)"
                                   href="javascript:void(0)">
                                    <i class="fa fa-fw fa-trash-alt"/> Delete Account
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="block-content">
            <div v-if="accounts.hasOwnProperty('meta')">
                <eml-pagination :data="accounts.meta.pagination"/>
            </div>
        </div>
        <transfer-credits dialog-id="transfer-credits-modal" :account="account" title="Transfer Credits/Units"/>
        <share-billing-account-dialog dialog-id="share-account-modal" :account="accountId"
                                      title="Share billing Account"/>
    </div>
</template>

<script>
    import TransferCredits from "./components/TransferCredits";
    import ShareBillingAccountDialog from "../../../components/billing/ShareBillingAccountDialog";
    import {mapGetters} from 'vuex';

    export default {
        props: {
            accounts: Object
        },
        components: {
            TransferCredits,
            ShareBillingAccountDialog
        },
        computed: {
            ...mapGetters({user: 'getAuthenticatedUser'})
        },
        data() {
            return {

                accountId: '',
                account: {
                    data: []
                }
            }
        },
        name: "BillingAccounts",
        mounted() {

        },
        methods: {
            openShareDialog(account) {
                this.accountId = account;
                jQuery('#share-account-modal').modal({backdrop: 'static', keyboard: false});
            },
            deleteAccount(id) {
                axios.delete(`billing/accounts/${id}`).then(res => {
                    this.$notify({
                        message: 'The account and all related transactions have been purged',
                        title: 'Account Deleted',
                        type: 'success'
                    });
                    this.$store.dispatch('getBillingAccounts');
                });
            },

            makeDefault(id) {
                axios.put(`billing/accounts/${id}/make-default`).then(res => {
                    this.$notify({
                        message: 'The account has been set as default',
                        title: 'Operation Successful',
                        type: 'success'
                    });
                    this.$store.dispatch('getBillingAccounts');
                })
            },

            viewAccount(account) {
                this.$router.push(`/accounts/${account}/overview`)
            },
            /**
             * Transfer Units from account
             *
             * @param id
             */
            transferCredits(id) {
                axios.get(`billing/accounts/${id}`).then(res => {
                    this.account = res.data.data;
                    jQuery('#transfer-credits-modal').modal({backdrop: 'static', keyboard: false});
                });
            },
        }
    }
</script>

<style scoped>

</style>
